import { MdxDiv } from '@features/mdx/MdxDiv';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '07a62706-ed1e-4da8-b5c6-8d1fcef5e424',
	[AppLanguageCodes.SK]: '07a62706-ed1e-4da8-b5c6-8d1fcef5e424',
	[AppLanguageCodes.DE]: '07a62706-ed1e-4da8-b5c6-8d1fcef5e424',
}


export const Infobox = () => {

	return (
		<MdxDiv className='info-box' articleIds={articleIds}>
		</MdxDiv>
	);
};